<template>
  <div class="columns mgt-20px is-multiline">
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.tab.produitStockParDefaut')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="$t('societes.tab.produitVente')">
                <b-select v-model="societe.produitVenteBonStockId" expanded>
                  <option></option>
                  <option v-for='produit in listeProduitVente'
                          :key="produit.id"
                          :value="produit.id">
                    {{ `${produit.libelle} - ${produit.reference}` }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('societes.tab.produitAchat')">
                <b-select v-model="societe.produitAchatBonStockId" expanded>
                  <option></option>
                  <option v-for='produit in listeProduitAchat'
                          :key="produit.id"
                          :value="produit.id">
                    {{ `${produit.libelle} - ${produit.reference}` }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { SENS_ACHAT, SENS_VENTE } from '@/configuration/devisConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllDivers } from '@/api/produit/produitDivers';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        SENS_ACHAT,
        SENS_VENTE,
      },
      listeProduitAchat: [],
      listeProduitVente: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
      const queryItems = {
        query: {
          societeId: this.societeActiveId,
          sens: SENS_ACHAT,
          stockable: 'true',
        },
        orderBy: 'ProduitDivers.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,
      };
      this.listeProduitAchat = (await getAllDivers(queryItems)).data.result.items;
      queryItems.query.sens = SENS_VENTE;
      this.listeProduitVente = (await getAllDivers(queryItems)).data.result.items;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },

};
</script>
